module.exports = __webpack_public_path__ + "img/home-delivery.a97b9dff.jpeg";